import { createRoutine } from 'app/common/utils/new-routines';
import { type ActionType, createAction } from 'typesafe-actions';
import type { Version } from './types.js';

export type VersionListRequest = {
  contentId: string;
  from?: number;
  size?: number;
};

export type VersionListResponse = {
  versionList: Version[];
};

export const getVersionListRoutine = createRoutine('version/GET_LIST')<
  undefined,
  VersionListRequest,
  undefined,
  VersionListResponse,
  string,
  undefined
>();

export const getContentVersionRoutine = createRoutine('version/GET_VERSION')<
  undefined,
  number | null,
  undefined,
  Version,
  string,
  undefined
>();

export const VIEW_CONTENT_DIFF = 'version/VIEW_CONTENT_DIFF';
export const viewContentDiff = createAction(VIEW_CONTENT_DIFF)<number | null>();
export type ViewContentDiffType = ActionType<typeof viewContentDiff>;

export const CLEAR_VERSION_LIST = 'version/CLEAR_VERSION_LIST';
export const clearVersionList = createAction(CLEAR_VERSION_LIST)();

export const RESTORE_VERSION_CONTENT = 'version/RESTORE_VERSION_CONTENT';
export const restoreVersionContent = createAction(RESTORE_VERSION_CONTENT)();

export type ContentArchivedPayload = {
  contentId: string;
  contentTypeId: string;
};

export const CONTENT_ARCHIVED = 'content/CONTENT_ARCHIVED';
export const contentArchived = createAction(CONTENT_ARCHIVED)<ContentArchivedPayload>();
export type ContentArchivedType = ActionType<typeof contentArchived>;

export const GET_NEXT_VERSION_LIST = 'version/GET_NEXT_VERSION_LIST';
export const getNextVersionList = createAction(GET_NEXT_VERSION_LIST)();
export type GetNextVersionListType = ActionType<typeof getNextVersionList>;
